module.exports = __webpack_public_path__ + "img/H1.7a2f2de3.png";